import React from 'react';

import EnterpriseManager from '../components/enterprise'

class EnterprisePage extends React.Component{

	render(){

		return (
			<div style={{margin: 16}}>
				<EnterpriseManager />
			</div>
		)
	}

}

export default EnterprisePage;


// WEBPACK FOOTER //
// ./src/containers/enterprise-page.js